import React from 'react'
import { Container } from 'react-bootstrap';
import './navbar/navbar.css';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Avatar from '@material-ui/core/Avatar';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterIcon from '@material-ui/icons/Twitter';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import IconButton from '@material-ui/core/IconButton';
//import trainerimg from "../assets/images/trainerimg.png";
import img2 from "../assets/images/lilya.jpg";
import img3 from "../assets/images/afif.jpeg";
import img4 from "../assets/images/habi.jpg";
import img5 from "../assets/images/azzize.jpg";
import img1 from "../assets/images/nazim.jpg";

export default function Trainer() {
    const [checked, setChecked] = React.useState(["trainer-paper","trainer-paper", "trainer-paper", "trainer-paper", "trainer-paper","trainer-paper", "trainer-paper", "trainer-paper", "trainer-paper"]);
  
    
    const updateFieldChanged = index => e => {
        let tempArr = [...checked];
        tempArr[index] = "trainer-paper-opened";
        setChecked(tempArr)
    }
    const updateFieldChangedOpened = index => e => {
        let tempArr = [...checked];
        tempArr[index] = "trainer-paper";
        setChecked(tempArr)
    }
   
    const trainers = [
        {
            source: img1,
            name: "Nazim Bendib",
            job: "School Of Ai Member",
            linkedInUrl: "https://www.linkedin.com/in/nazim-bendib-894167200/",
            twitterUrl: "",
        },
        {
            source: img2,
            name: "Lilya Yahiaoui",
            job: "Master student at USTHB",
            linkedInUrl: "https://www.linkedin.com/in/lilya-yahiaoui/",
            twitterUrl: "/",
        }, {
            source: img3,
            name: "Afif Boudaoud ",
            job: "Ex VP of SOAI, Zindi ambassador ",
            linkedInUrl: "https://www.linkedin.com/in/khaled-boudaoud/",
            twitterUrl: "",
        }, {
            source: img4,
            name: "Mohamed Habi",
            job: "Dev manager at SOAI",
            linkedInUrl: "https://www.linkedin.com/in/mohamed-habi/",
            twitterUrl: "",
        },
        {
            source: img5,
            name: "Azzedine Chenine",
            job: " AI Research Engineer at InstaDeep ",
            linkedInUrl: "https://www.linkedin.com/in/azzedine-chenine-8a287366/",
            twitterUrl: "",
        }
    ]
    return (
        <section id="Trainers">
            <Container className="trainer-container" >
                <h1>Our Trainers</h1>
                <Grid container className="" spacing={1}>
                    <Grid item xs={12}>
                        <Grid container justify="center" spacing={8}>
                            {trainers.map((trainer, index) => (

                                <Grid key={index} item>

                                    <Paper className={checked[index]} >
                                        <Avatar className="trainer-img" alt="Remy Sharp" src={trainer.source} />
                                        {(checked[index] !== "trainer-paper-opened") ?
                                            <IconButton className="card-extend" onClick={updateFieldChanged(index)}

                                                color="primary" aria-label=" " component="span">
                                                <ExpandMoreIcon className="extend-card" />
                                            </IconButton>
                                            : <>
                                                <div className="card-text-container">
                                                    <h1>{trainer.name}</h1>
                                                    <h4>{trainer.job}</h4>
                                                </div>
                                                <div>
                                                  
                                                  
                                                    <a href={trainer.linkedInUrl} target="_blank" rel="noreferrer">
                                                        <IconButton
                                                            className="social" aria-label=" " component="span">
                                                            <LinkedInIcon />
                                                        </IconButton>
                                                    </a>
                                                    <a href={trainer.twitterUrl} target="_blank" rel="noreferrer">
                                                        <IconButton
                                                            className="social" aria-label=" " component="span">
                                                            <TwitterIcon />
                                                        </IconButton>
                                                    </a>
                                                </div>
                                                <IconButton className="card-extend" onClick={updateFieldChangedOpened(index)}

                                                    color="primary" aria-label=" " component="span">
                                                    <ExpandLessIcon className="extend-card" />
                                                </IconButton>
                                            </>

                                        }

                                    </Paper>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>

                </Grid>
            </Container>

        </section>
    )

}

